<template>
  <FontAwesomeIcon
    aria-hidden
    :icon="[weight, icon]"
    :style="{
        color: colorAsHexadecimal,
        width: `${sizeAsPixel}px`,
        height: `${sizeAsPixel}px`,
      }"
  />
</template>

<script lang="ts">
import { IconName } from '@awesome.me/kit-da13514c94/icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { defineComponent, PropType } from 'vue'
import { useTheme } from 'vuetify'

import { ThemeColors } from '@/plugins/styles/colors'

const APP_ICON_SIZES = {
  'xxs': 12,
  'xs': 16,
  'sm': 20,
  'md': 24,
  'lg': 28,
  'xl': 32,
  'xxl': 48,
}

type AppIconWeight = 'far' | 'fas' | 'fak'
type AppIconSize = keyof typeof APP_ICON_SIZES

/**
 * @displayName Basic Icon
 */
export default defineComponent({
  name: 'AppIconDs',
  setup () {
    const theme = useTheme()
    return {
      themeColors: theme.current.value.colors,
    }
  },
  components: { FontAwesomeIcon },
  props: {
    /**
     * Icon color, use design system color tokens
     */
    color: {
      type: String as PropType<ThemeColors>,
      default: 'grey-600',
    },
    /**
     * Icon name, use FontAwesome icon names
     */
    icon: {
      type: String as PropType<IconName>,
      required: true,
    },
    /**
     * Icon size, possible values : 'xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl'
     */
    size: {
      type: String as PropType<AppIconSize>,
      default: 'md',
    },
    /**
     * Icon weight, possible values : 'fas' (solid), 'far' (regular), 'fak' (for custom icons)
     */
    weight: {
      type: String as PropType<AppIconWeight>,
      default: 'far',
    },
  },
  computed: {
    colorAsHexadecimal () {
      return this.themeColors[this.color]
    },
    sizeAsPixel () {
      return APP_ICON_SIZES[this.size]
    },
  },
})
</script>

<style lang="scss" scoped>
.svg-inline--fa {
  &:focus {
    outline: none;
  }
}
</style>